import React from "react";
import PageLayout from "../../components/PageLayout";
import withRouter from "../../components/Common/withRouter";



const DynamicModule = props => {
  const pageName = "Dynamic Module"
  const moduleName= props.router.params.moduleName

  console.log(props);
  
  const breadcrumbItems = [
    { text: "Home", link: "/" },
    { text: pageName, link: "/dynamic-module" },
    { text: moduleName, link: props.router.location.pathname },
  ];
  return (
    <React.Fragment>
      <PageLayout pageName={pageName} breadcrumbItems={breadcrumbItems}>
        <div className="dash-board">
          <h2>Dynamic Module / {moduleName}</h2>
        </div>
      </PageLayout>
    </React.Fragment>
  );
};

export default withRouter(DynamicModule);
